<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <Varieties :showParent="showParent" :canManage="canManage" :varietyGroupId="varietyGroupId" />
    </div>
</template>

<script>
import currentUserQuery from '@views/Varieties/Browse/queryCurrentUser.graphql';
import findVarietyGroupQuery from '@views/Varieties/Browse/queryFindVarietyGroup.graphql';

import Varieties from '../Varieties/Browse.vue';

export default {
  name: 'VarietiesContainer',
  props: {
    varietyGroupId: {
      required: true,
    },
  },
  components: {
    Varieties,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
    varietyGroup: {
      query: findVarietyGroupQuery,
      update: data => data.findVarietyGroup,
      variables() {
        return {
          input: {
            id: this.varietyGroupId,
          },
        };
      },
    },
  },
  watch: {
    currentUser() {
      if (this.currentUser && this.varietyGroup) {
        const validRole = ['association', 'developer', 'admin'].includes(this.currentUser.role.name);
        const validCropType = this.currentUser.role.name !== 'association' || this.associationCropType === this.varietyGroup.cropType.id;

        if (!validRole || !validCropType) {
          this.$notifyFailure('Not allowed.');
          setTimeout(() => this.$router.push({ name: 'dashboard' }), this.$redirectTimeout);
        }
      }
    },
  },
  data() {
    return {
      currentUser: null,
      loading: 0,
    };
  },
  methods: {},
  computed: {
    associationCropType() {
      return this.$path.get(this, 'currentUser.managedAssociation.crop_type_id');
    },
    showParent() {
      return this.currentUser.role.name !== 'association';
    },
    canManage() {
      return true;
    },
  },
};
</script>
